// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2fbf66b5","455":"fd6eb063"}[chunkId] + ".chunk.js";
};